import { render, staticRenderFns } from "./CustomerSections.vue?vue&type=template&id=71818ed0&"
import script from "./CustomerSections.vue?vue&type=script&lang=ts&"
export * from "./CustomerSections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports